"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function createReporter(honeybadger) {
    if (!honeybadger) {
        return (error) => {
            console.error(error);
        };
    }
    return (error, context) => {
        if (context) {
            honeybadger.setContext(context);
        }
        if (typeof error !== 'string') {
            honeybadger.setContext({ request: error.request, response: error.response });
        }
        honeybadger.setContext({ tags: 'frontend' });
        honeybadger.notify(error);
        honeybadger.clear();
    };
}
exports.default = createReporter;
//# sourceMappingURL=createReporter.js.map